import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { useEffect } from 'react';
import { routes } from '../consts/consts'; // Import routes
import AddInvestment from '../components/investments/addInvestment/AddInvestment';
import Investment from '../components/investments/Investment';
import Requests from '../components/inquiryRequests/Requests';
import Profile from '../components/profile/Profile';
import AddService from '../components/companyServices/AddService';
import EditService from '../components/companyServices/EditService';
import ServicesTable from '../components/companyServices/ServicesTable';
import EditInvestment from '../components/investments/addInvestment/EditInvestment';
import AddProject from '../components/completedProjects/AddProject';
import EditProject from '../components/completedProjects/EditProject';
import ProjectsTable from '../components/completedProjects/ProjectTable';
import Handle404 from './Handle404';
import Documents from '../components/documents/Documents';

export default function ProtectedRoutes() {
  return (
    <MainLayout>
      <Routes>
        <Route path={routes.investments} element={<Investment />} />
        <Route path={routes.AddInvestment} element={<AddInvestment />} />
        <Route path={routes.editInvestment} element={<EditInvestment />} />
        <Route path={routes.addService} element={<AddService />} />
        <Route path={routes.serviceTable} element={<ServicesTable />} />
        <Route path={routes.editService} element={<EditService />} />
        <Route path={routes.inquiryRequests} element={<Requests />} />
        <Route path={routes.projectTable} element={<ProjectsTable />} />
        <Route path={routes.addProject} element={<AddProject />} />
        <Route path={routes.editProject} element={<EditProject />} />
        <Route path={routes.profile} element={<Profile />} />
        <Route path={routes.documents} element={<Documents />} />
        {/* Catch-all route for unhandled paths */}
        <Route path="/*" element={<Handle404 />} />
      </Routes>
    </MainLayout>
  );
}
